//
//
//
//
//
//
//
//

export default {
	data(){
		return{
			scrollTop:0,
			btnFlag:false
		}
	},
	mounted(){



	},
	methods:{
		scrollToTop () {
		      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		      this.scrollTop = scrollTop
		      if (this.scrollTop > 360) {
		        this.btnFlag = true
		      } else {
		        this.btnFlag = false
		      }
		    },
			backTop () {
			      // document.body.scrollTop = 0
			      // document.documentElement.scrollTop = 0
			      // 设置定时器
			      let that = this
			      let timer = setInterval(() => {
			        let ispeed = Math.floor(-that.scrollTop / 5)
			        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
			        if (that.scrollTop === 0) {
			          clearInterval(timer)
			        }
			}, 16)
		}
	}
}
